import {
  isWxWorkSaas,
  getCookie,
  setCookie,
  isTestEnv,
  deleteURLSearch,
  isPreReleaseEnv,
  getRequest,
  awaitWrap,
  getEmonitor,
  jumpScheme,
  isMobile,
  loadJweixinScript,
  isWeiXinGte656,
  isVoovEnv,
  randomString,
  addURLSearch,
} from './util';
import $http from './../user-center/http';
import { TX_CORP_ID, MEETING_TYPE } from './../../web-tools/utils/constant';

const IS_I18N = process.env.IS_I18N === 'true';

/**
 * 拉起会议类型
 */
export const LAUNCH_TYPE = {
  NORMAL_MEETING_LAUNCH: 1, // 普通拉起
  QR_CODE_LAUNCH: 2, // 特邀二维码
  APP_LAUNCH: 3, // 打开app
};

const filterXss = text => text.replace(/[<>"()]/g, '');

let launchAppStartTime = null;
let checkLaunchIdCount = 0;

/**
 * 上报info日志
 */
let logInfo = () => { };

const invokeLaunchApp = (schemaUrl, failCallback) => {
  let originUrl = schemaUrl;
  let newSchemaUrl = schemaUrl;
  if (isTestEnv()) {
    newSchemaUrl = newSchemaUrl.replace('wemeet', 'wwauth3rd4806d2ddf553eb8b');
    console.log('>>>invokeLaunchApp test url', newSchemaUrl);
  }
  if (isPreReleaseEnv()) {
    newSchemaUrl = newSchemaUrl.replace('wemeet', 'wwauth3rd3a82ac41e00d815d');
    console.log('>>>invokeLaunchApp prerelease url', newSchemaUrl);
  }
  newSchemaUrl = newSchemaUrl.replace('wemeet', 'wwauth3rdca2b0d866939bfde');
  newSchemaUrl = addURLSearch(newSchemaUrl, { platformId: 'wxwork' });

  console.log('>>>invokeLaunchApp schemaUrl', newSchemaUrl);
  console.log('>>>invokeLaunchApp window.wx', window.wx.invoke);
  window.wx && window.wx.invoke && window.wx.invoke('launchApplication', {
    schema: newSchemaUrl,
  }, async (res1) => {
    console.log('launchApplication res1', res1);
    if (res1.err_msg === 'launchApplication:ok') {
      logInfo('launchApplication success', res1);
      return;
    }
    logInfo('launchApplication failted!!', res1);
    if (isMobile()) {
      typeof failCallback === 'function' && failCallback();
      return;
    }
    originUrl = addURLSearch(originUrl, { platformId: 'wxwork' });
    schemaLaunch(originUrl);
  });
};

/**
 * jsapi唤起场景
 * @param {*} schemaUrl
 * @param {*} failCallback
 */
const jsApiLaunch = (schemaUrl, failCallback) => {
  window.wx && window.wx.checkJsApi && window.wx.checkJsApi({
    jsApiList: ['launchApplication'],
    success: (res) => {
      if (res.errMsg === 'checkJsApi:ok' && res.checkResult.launchApplication) {
        console.log('>>> checkJsApi launchApplication success');
        invokeLaunchApp(schemaUrl, failCallback);
        return;
      }
      logInfo('checkJsApi failed!!', res);
      typeof failCallback === 'function' && failCallback();
    },
    fail: () => {
      console.log('>>> checkJsApi launchApplication fail');
      logInfo('checkJsApi failed!!');
      typeof failCallback === 'function' && failCallback();
    },
  });
};

/**
 * schema唤起场景
 * @param {*} schemaUrl
 * @param {*} jumpCallback
 */
const schemaLaunch = async (schemaUrl, jumpCallback, reportCallback) => {
  const res = await jumpScheme(schemaUrl, !!window.debugMode, reportCallback);
  typeof jumpCallback === 'function' && jumpCallback(res);
};

const createLaunchId = (launchId) => {
  $http.post({
    url: '../service/create-launch-id',
    data: {
      id: launchId,
    },
    response: (res) => {
      console.log('create-launch-id res:', res);
    },
  }).catch((err) => {
    console.log('create-launch-id err:', err);
  });
};

const checkLaunchId = (launchId, cb) => {
  $http.get({
    url: '../service/query-launch-id',
    data: {
      id: launchId,
    },
    response: (res) => {
      console.debug('query launch id res:', res);
      checkLaunchIdCount += 1;
      if (res.value === 1) { // 唤起成功
        cb && cb.success && cb.success(launchAppStartTime);
      } else {
        // keep asking
        let ms = 1000;
        if (checkLaunchIdCount > 20) {
          ms = 2000;
        }
        if (checkLaunchIdCount === 20) { // 唤起失败
          cb && cb.fail && cb.fail(launchAppStartTime);
        }
        if (checkLaunchIdCount < 40) {
          setTimeout(() => {
            checkLaunchId(launchId, cb);
          }, ms);
        }
      }
    },
  });
};

/**
 * 是否通过jsapi唤起判断
 * saas企业微信中 & 不是腾讯的企业 & 不是特邀二维码唤起 => 通过jsapi唤起
 * @param {*} meetingType 会议类型
 * @param {*} launchMode 特邀唤起模式0-普通或无效 1-小程序 2-二维码
 */
const isJsApiLaunch = (meetingType, launchMode) => {
  const corpId = getCookie('wework_corp_id');
  let fromQrCode = false;
  if (meetingType === MEETING_TYPE.SPECIALLY_INVITED_MEETING && launchMode === 2) {
    fromQrCode = true;
  }
  return isWxWorkSaas() && corpId && corpId !== TX_CORP_ID && !fromQrCode;
};

const getSignatureWithCorpID = corpId => new Promise((resolve, reject) => {
  $http.get({
    url: 'v2/account/qy-wechat/get-signature-without-login',
    data: {
      corp_id: corpId,
      url: window.location.href,
    },
  }).then((res) => {
    logInfo('api: v2/account/qy-wechat/get-signature-without-login - then', res);
    resolve(res);
  })
    .catch((err) => {
      logInfo('api: v2/account/qy-wechat/get-signature-without-login - catch', err);
      reject(err);
    });
});

const getSignatureWithCode = code => new Promise((resolve, reject) => {
  $http.get({
    url: 'v2/account/qy-wechat/get-signature-with-code',
    data: {
      code,
      url: window.location.href,
    },
  }).then((res) => {
    logInfo('api: v2/account/qy-wechat/get-signature-with-code - then', res);
    resolve(res);
  })
    .catch((err) => {
      logInfo('api: v2/account/qy-wechat/get-signature-with-code - catch', err);
      reject(err);
    });
});

/**
 * window.wx.ready初始化
 * @param {*} param0
 */
const wxWorkConfig = ({ data, code }) => new Promise((resolve, reject) => {
  console.log('>>>>>wxWorkConfig data', data);
  if (Number(code) === 0 && data && data.corpId) {
    setCookie('wework_corp_id', data.corpId, 30);
  } else {
    reject();
    return;
  }
  const configData = {
    beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.corpId, // 必填，企业微信的corpID
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.noncestr, // 必填，生成签名的随机串
    signature: data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
    jsApiList: ['launchApplication'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
  };
  console.log('>>>>>wxWorkConfig configData', configData);
  window.wx.config(configData);
  window.wx.ready(() => {
    const agentConfigData = {
      corpid: data.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
      agentid: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.noncestr, // 必填，生成签名的随机串
      signature: data.app_signature, // 必填，签名
      jsApiList: ['launchApplication'], // 必填
      success(res) {
        console.log('wx ready success', res);
        logInfo('wxWorkConfig: window.wx.ready', res);
        // 成功初始化
        resolve(res);
      },
      fail(res) {
        console.log('wx ready fail', res);
        logInfo('wxWorkConfig: wx ready fail', res);
        if (res.errMsg.indexOf('function not exist') > -1) {
          alert('版本过低请升级');
        }
        reject(res);
      },
    };
    console.log('>>>>>wxWorkConfig agentConfigData', agentConfigData);
    window.wx.agentConfig(agentConfigData);
  });
  window.wx.error((res) => {
    console.log('>>>>>wxWorkConfig error', res);
    logInfo('wxWorkConfig: wx error', res);
    reject(res);
  });
});

const resHandler = (resData, err) => new Promise((resolve, reject) => {
  if (err) {
    reject(err);
    return false;
  }
  wxWorkConfig((resData || {})).then((res) => {
    resolve(res);
  })
    .catch((res) => {
      reject(res);
    });
});

/**
 * 跳转换链
 */
const redirect = () => {
  if (isTestEnv()) {
    if (IS_I18N) {
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww3a24940e95296ca3&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`);
    } else {
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww4806d2ddf553eb8b&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`);
    }
  } else if (isPreReleaseEnv()) {
    window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww3a82ac41e00d815d&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`);
  } else {
    if (IS_I18N) {
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwd5968e076e21ca07&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`);
    }  else {
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwca2b0d866939bfde&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`);
    }
  }
};

/**
 * Saas企业微信下初始化
 */
const saasWxInit = async () => {
  if (!window.$util || !window.$util.jweixinScriptReady) {
    console.log('>>>>>saasWxInit loadJweixinScript');
    await loadJweixinScript('https://res.wx.qq.com/open/js/jweixin-1.2.0.js');
  }
  const corpId = getCookie('wework_corp_id');
  const code = getRequest('code');
  let [resData, err] = [null, null];
  if (corpId) {
    console.log('>>>>>saasWxInit getSignatureWithCorpID');
    [resData, err] = await awaitWrap(getSignatureWithCorpID(corpId));
    return resHandler(resData, err);
  }
  if (code) {
    console.log('>>>>>saasWxInit getSignatureWithCode');
    window.history.replaceState(
      { url: window.location.href },
      document.title,
      deleteURLSearch(deleteURLSearch(window.location.href, 'code'), 'state'),
    );
    [resData, err] = await awaitWrap(getSignatureWithCode(code));
    return resHandler(resData, err);
  }
  redirect();
};

/**
 * 唤起腾讯会议app初始化入口
 */
export const initLaunch = () => {
  if (isWxWorkSaas()) {
    return saasWxInit();
  }
  // todo 待添加sso唤起初始化
};

// voov 专用的微信环境特殊处理

const voovLaunch = (schemaUrl, jumpCallback, reportCallback, page, handleVoovJumpMeetingDetailPage) => {
  const isWechatEnv = () => {
    return isWeiXinGte656();
  };

  const setVoovTestEnvOrigin = (page) => {
    return (location.href = `https://test.txmeeting.tencent.com/df/en/${page}.html${filterXss(
      window.location.search
    )}&subpage=launch`);
  };

  const setVoovNormalEnvOrigin = (page) => {
    return (location.href = `https://meeting.tencent.com/df/en/${page}.html${filterXss(
      window.location.search
    )}&subpage=launch`);
  };

  const setVoovOrigin = (page = 'detail') => {
    if (isTestEnv()) {
      return setVoovTestEnvOrigin(page);
    }
    return setVoovNormalEnvOrigin(page);
  };

  const showDetailContainer = (handleVoovJumpMeetingDetailPage) => {
    const appCtrlEl = document.getElementById('appCtrl');
    if (appCtrlEl) {
      appCtrlEl.style.display = 'block';
    }
    const launchContainerEl = document.getElementById('launch-app-container');
    if (launchContainerEl) {
      launchContainerEl.style.display = 'block';
    }
    const detailContainerEl = document.getElementById('detail-container');
    if (detailContainerEl) {
      detailContainerEl.style.display = 'none';
    }
    handleVoovJumpMeetingDetailPage();
  };

  const voovLaunchInWechat = (
    schemaUrl,
    jumpCallback,
    reportCallback,
    page,
    handleVoovJumpMeetingDetailPage,
  ) => {
    if (isVoovEnv()) {
      return setVoovOrigin(page);
    }
    showDetailContainer(handleVoovJumpMeetingDetailPage);
    return schemaLaunch(schemaUrl, jumpCallback, reportCallback);
  };

  if (isWechatEnv()) {
    return voovLaunchInWechat(schemaUrl, jumpCallback, reportCallback, page, handleVoovJumpMeetingDetailPage);
  }
  return schemaLaunch(schemaUrl, jumpCallback, reportCallback);
};

/**
 * 唤起腾讯会议app入口
 *
 * 1. 海外企业微信链接唤起
 *
 * 2. jsapi唤起
 *
 *  （平台）saas企业微信，（企业）非腾讯，（链接）除特邀二维码all
 *
 * 3. schema跳转唤起
 *
 *  （平台）saas企业微信，（企业）非腾讯，（链接）特邀二维码链接
 *
 *  （平台）saas企业微信，（企业）腾讯，（链接）all
 *
 *  （平台）私有化企业微信，（企业）all，（链接）all
 *
 *  （平台）非企业微信，（企业）all，（链接）all
 *
 * @param {*} initRes 初始化结果promise
 * @param {*} isVoov 是否海外企业微信
 * @param {*} schemaUrl 唤起链接
 * @param {*} launchId 业务可通过randomString(16)方法生成
 * @param {*} meetingType 会议类型，默认普通会议
 * @param {*} launchMode 0或者没有，普通会议；1，特邀会议小程序，2. 特邀会议扫毛，默认0
 * @param {*} defaultLogic 调用方定制容错逻辑（fail-调用出错回调，jumpCallback-微信版本过低提示回调, reportCallback-shcema跳转灯塔上报）
 * @param {*} launchCallback 唤起app之后回调逻辑（success-成功回调，fail-失败回调）
 */
export const launchApp = async (params) => {
  const {
    initLaunchRes,
    isVoov,
    launchId,
    meetingType = MEETING_TYPE.NORMAL_MEETING,
    launchMode = 0,
    defaultLogic,
    launchCallback,
    handleVoovJumpMeetingDetailPage,
    logId = randomString(15),
    page,
  } = params;
  let { schemaUrl } = params;
  logInfo = (title = '', info = {}) => {
    getEmonitor().log({
      level: 1, // debug:0, info: 1, warn: 2, error: 3;
      log: {
        title,
        info,
        logId,
      },
    });
  };

  const launchCallbackFunc = () => {
    setTimeout(() => {
      checkLaunchIdCount = 0;
      checkLaunchId(launchId, launchCallback);
    }, 1000);
  };

  // voov meeting 唤起转发至tecent.com
  if (isVoov) {
    voovLaunch(
      schemaUrl,
      defaultLogic.jumpCallback,
      defaultLogic.reportCallback,
      page,
      handleVoovJumpMeetingDetailPage,
    );
    // voov 也需要 check launch id
    createLaunchId(launchId);
    launchCallbackFunc();
    return;
  }
  if (isJsApiLaunch(meetingType, launchMode)) {
    console.log('>>> jsApiLaunch');
    logInfo('jsApiLaunch');
    (await initLaunchRes) && jsApiLaunch(schemaUrl, defaultLogic.fail);
    return;
  }
  console.log('>>> schemaLaunch');
  logInfo('schemaLaunch');
  schemaLaunch(
    schemaUrl,
    defaultLogic.jumpCallback,
    defaultLogic.reportCallback,
  );

  launchAppStartTime = new Date();
  createLaunchId(launchId);

  launchCallbackFunc();
};
